// The section fly-out's keyboard contract: it takes focus when the keyboard
// opened it, and Escape closes it and hands focus back.

import { useEffect, type RefObject } from 'react';

import { useModalLayer } from './useModalLayer';

export function useFlyoutKeyboard(
  surfaceRef: RefObject<HTMLElement | null>,
  autoFocus: boolean,
  onClose: (restoreFocus?: boolean) => void,
): { isTopmost: () => boolean } {
  const { isTopmost } = useModalLayer('nav-flyout');

  useEffect(() => {
    if (!autoFocus) return;
    surfaceRef.current?.querySelector<HTMLElement>('a, button:not(:disabled)')?.focus();
  }, [autoFocus, surfaceRef]);

  // Gated on the modal stack so a fly-out left open under the search palette
  // does not swallow the press meant for the palette.
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isTopmost()) onClose(true);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isTopmost, onClose]);

  return { isTopmost };
}
